import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets  = ['progress']
  connect(){

  }
  updateProgress(e){
    const progress = e.detail.progress <= 100 ? e.detail.progress : 100;
    this.progressTarget.style.width = progress + '%'
  }
}
